import {Box, Grid, Radio, RadioGroup, Stack, Typography} from "@mui/material";
import {Trans, useTranslation} from "react-i18next";
import {ChangeEvent} from "react";
import {UploadDataType} from "../../../types/uploadDataEnums";
import {RainDrop} from "./RainDrop";

export interface Props {
    dataType: UploadDataType;
    setDataType: (value: UploadDataType) => void;
}

export const DataUploadOptionsView: React.FC<Props> = ({dataType, setDataType}) => {
    const {t} = useTranslation();

    const dataTypeChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setDataType(event.target.value as UploadDataType);
    };

    const downloadExamleCsv = () => {
        const data = [
            ["date", "fieldId", "rainfall", "irrigation"],
            ["2025-01-01", "1c926207-b974-4b50-966e-896622d994ff", "1", "1"],
        ];

        const csvContent = data.map((row) => row.join(",")).join("\n");
        const blob = new Blob([csvContent], {type: "text/csv;charset=utf-8;"});
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "data.csv");
        link.style.visibility = "hidden";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Grid item xs={12}>
            <strong>{t("dialogs.data_upload.subtitle")}</strong>
            <RadioGroup value={dataType} onChange={dataTypeChanged}>
                <Box padding="1.5rem 36px">
                    <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap="2rem">
                        <Stack direction="row" alignItems="flex-start" gap="1.5rem" flex="1">
                            <Box sx={{marginTop: "50px"}}>
                                <Radio value={UploadDataType.IRRIGATION_RAINFALL} sx={{padding: 0, height: "24px"}} />
                            </Box>
                            <Box sx={{marginTop: "30px"}}>
                                <RainDrop />
                            </Box>
                            <Stack direction="column" alignItems="flex-start" maxWidth="340px">
                                <Typography fontSize="16px" fontWeight={500} textTransform="uppercase">
                                    {t("dialogs.data_upload.irrigation_rainfall.type")}
                                </Typography>
                                <Typography fontWeight={400} fontSize="14px">
                                    {t("dialogs.data_upload.irrigation_rainfall.description")}
                                </Typography>
                            </Stack>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" gap="1.5rem" flex="1">
                            <Box sx={{marginTop: "50px"}}>
                                <Radio value={UploadDataType.CSV_UPLOAD} sx={{padding: 0, height: "24px"}} />
                            </Box>
                            <Box sx={{marginTop: "30px"}}>
                                <RainDrop />
                            </Box>
                            <Stack direction="column" alignItems="flex-start" maxWidth="340px">
                                <Typography fontSize="16px" fontWeight={500} textTransform="uppercase">
                                    {t("dialogs.data_upload.csv_upload.type")}
                                </Typography>
                                <Typography fontWeight={400} fontSize="14px">
                                    <Trans
                                        i18nKey="dialogs.data_upload.csv_upload.description"
                                        components={{
                                            button: (
                                                <Typography
                                                    component="span"
                                                    onClick={() => {
                                                        downloadExamleCsv();
                                                    }}
                                                    sx={{
                                                        color: "primary.main",
                                                        textDecoration: "underline",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    {t("dialogs.data_upload.csv_upload.type")}
                                                </Typography>
                                            ),
                                        }}
                                    />
                                </Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                </Box>
            </RadioGroup>
        </Grid>
    );
};
